/** @format */

import {styled} from '@mui/material/styles';
import {Box, Button, Typography} from '@mui/material';

export const Root = styled(Box)(({theme}) => ({
  overflow: 'hidden',
  borderRadius: '32px',
  position: 'relative',
  background: theme.palette.figma_surface?.main,
}));

export const Content = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(8),
  position: 'relative',
  zIndex: 0,
  padding: theme.spacing(6),
}));

export const TariffBorderBlock = styled(Box)(({theme}) => ({
  borderRadius: '8px',
  border: `1px solid ${theme.palette.figma_gray_dark_4?.main}`,
  overflow: 'hidden',
  display: 'flex',
  flexWrap: 'wrap',
  gap: '1px',
  background: theme.palette.figma_gray_dark_4?.main,
}));

export const TariffBlock = styled(Box)(({theme}) => ({
  // ширина по содержимому, но остаток строки блоки делят между собой:
  // иначе после переноса на строке остаётся пустое место
  width: 'max-content',
  flexGrow: 1,
  background: theme.palette.figma_surface?.main,
  padding: theme.spacing(4),
}));

export const BlockWrap = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(6),
}));

export const RegularText = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_gray_light_4?.main,
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
}));

export const InlineTextBox = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',
}));

export const OldPriceText = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_surface_muted?.main,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
  textDecorationLine: 'line-through',
}));

export const HintText = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_surface_muted?.main,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
}));

export const ActualPriceText = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_gray_light_4?.main,
  fontSize: '18px',
  fontWeight: 400,
  lineHeight: '22px',
}));

export const BigText = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_gray_light_4?.main,
  fontSize: '32px',
  fontWeight: 400,
  lineHeight: '36px',
}));

export const DiscountBadge = styled(Box)(({theme}) => ({
  height: '28px',
  padding: theme.spacing(0, 2),
  borderRadius: '100px',
  background: '#4C753B',
  display: 'flex',
  alignItems: 'center',

  color: '#D8E9D2',
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '20px',
  letterSpacing: '0.16px',
}));

export const ModalButtonsBox = styled(Box)(() => ({
  borderRadius: '8px',
  overflow: 'hidden',
  display: 'flex',
  gap: '1px',
}));

export const ModalButton = styled(Button)(({theme}) => ({
  background: theme.palette.figma_primary?.dark,
  height: '48px',
  borderRadius: 0,
  gap: theme.spacing(2),

  color: theme.palette.semantic_dark?.primary.on,
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',

  '&.Mui-disabled': {
    background: '#24394a',
    color: '#6e6f70',
  },
}));

export const MessageBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const BigGreenText = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_emerald?.main,
  fontSize: '32px',
  fontWeight: 500,
}));

export const GreenIconWrap = styled(Box)(({theme}) => ({
  color: theme.palette.figma_emerald?.main,
}));

export const MessageModalButtonsBox = styled(Box)(({theme}) => ({
  display: 'flex',
  borderRadius: '8px',
  border: `1px solid ${theme.palette.figma_emerald?.main}`,
  marginTop: theme.spacing(10),
  overflow: 'hidden',
}));

export const CloseButton = styled(Button)(({theme}) => ({
  background: 'none',
  height: '48px',
  width: '100%',
  borderRadius: 0,

  color: theme.palette.figma_emerald?.main,
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
}));

export const GoToProjectsButton = styled(Button)(({theme}) => ({
  background: theme.palette.figma_emerald?.main,
  height: '48px',
  width: '100%',
  borderRadius: 0,

  color: '#F9FCFA',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
}));

export const ModalBgDecoration = styled(Box)(() => ({
  width: '100%',
  position: 'absolute',
  zIndex: 1,
  bottom: 0,
  left: 0,
  pointerEvents: 'none',
  userSelect: 'none',

  img: {
    transform: 'translateY(5px)',
    width: '100%',
  },
}));
